import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as FPT from '../utility/fpt'
import { Cpf } from 'guest-payment';

const CpfComponent = React.createClass({

	propTypes: {
		label: PropTypes.string,
		warnings: PropTypes.object,
		onRef: PropTypes.func,
		handleChange: PropTypes.func,
	},

	getInitialState() {
		return {};
	},

	componentDidMount() {
		this.props.onRef(this)
	},

	componentWillUnmount() {
		this.props.onRef(undefined)
	},

	handleRequiredField(cpf) {
		return this.cpfComponent.validateAndShowError();
	},

	handleCpfError(errorMessageCode) {
		this.setState({
			errorMessageCode: errorMessageCode
		});
	},

	render() {
		const cpfProps = this.props.cpf;
		const cpfFieldlabel = cpfProps.label;
		const warnings = cpfProps.warnings;

		return (
			<div className="row cpf-component">
				<div className="col-xs-12">
					<Cpf
						ref={(cpf) => (this.cpfComponent = cpf)}
						country={this.props.country}
						label={cpfFieldlabel}
						warnings={warnings}
						handleChange={this.props.handleChange}
						errorMessageCode={this.state.errorMessageCode}
					/>
				</div>
			</div>
		);
	}
})

export default CpfComponent;



// WEBPACK FOOTER //
// ./containers/cpf-component.js